import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ThemeMenuNavlink from '../Theme/ThemeMenuNavlink'

function ThemeMenuSideBar() {
  const [menu, setMenu] = useState([]);

  const loadMenu = async () => {
    let authentication = JSON.parse(localStorage.getItem("authenticated"));
    let sessid = authentication.sessid;
    let session_name = authentication.session_name;
    let session_token = authentication.token
    const data =  await axios.get(process.env.REACT_APP_DRUPAL_PATH+'/mp_menu_api/menu/menu-manpower-main-menu',
    { 
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": session_token,
        "Authentication": session_name+"="+sessid,
        "Cache-Control": "no-cache",
    },
    });
    const json = await data.data.tree;      
    setMenu(json);
  }
  useEffect(() => {    
    loadMenu()
    .catch(console.error);        
  },[]);

  
  return (    
    <>
      {menu && 
        menu.map((m) =>
          <ThemeMenuNavlink key={m.mlid} mid={m.mlid} mtitle={m.title} mchild={m.children} />
        )
      }
    </>    
  )
}

export default ThemeMenuSideBar